<mat-dialog-content class="mat-typography" style="max-width: 400px; text-align:center">
    @if (data.template) {
        <p>Update the content of the existing template<p>
        <button mat-raised-button [disabled]="!ready" color="primary" (click)="updateExisting()">Update: {{data.template.title}}</button>
        <p>OR</p>
    }
    <app-ctl-holder [control]="title.control" on="form"></app-ctl-holder>
    <button mat-raised-button color="primary" [disabled]="!title.control.valid || !ready" (click)="createNew()">Create New Template</button>    
</mat-dialog-content>